import React from 'react';

const Footer = () => (
  <footer className="bg-sky-500 text-white text-center p-4 w-full">
    <p>&copy; 2024 Consult@IAhmed. All rights reserved.</p>
  </footer>
);

export default Footer;